var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-dynamicTela",attrs:{"id":"dynamicTela"}},_vm._l((_vm.definitionList),function(item){return _c('dynamicCell',{key:item.field,attrs:{"value":item,"gridUtils":_vm.gridUtils,"telaSpace":_vm.telaSpace}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }